import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mangaList } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

export default function FeaturedSection() {
  const { t } = useTranslation();
  const featured = mangaList.filter((m) => m.rating >= 4.6).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              {t('home.featured.title')}
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              {t('home.featured.subtitle')}
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap font-medium cursor-pointer"
          >
            {t('home.featured.viewAll')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
          >
            {t('home.featured.viewAll')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}